import React, { useState, useEffect, useCallback } from "react";
import { Modal, DatePicker, TimePicker, Space, message } from "antd";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import WhoAllCharts from "../../charts/WhoAllCharts";
import images from "../../../../themes/appImage";
import appconstant from "../../../../themes/appconstant";
import {
  requestScoreLoad,
  requestScoreFail,
  editrequestScoreLoad,
  getWhoScoreLoad,
} from "../../../../redux/slices/dash.slice";

let editReq = false;
const Who = ({ myid }) => {
  const dispatch = useDispatch();
  const { whoAssessmentSuccess, lastReqAssesmentData, upcomingAssessmentDate } =
    useSelector((state) => state.dashboardReducer);

  const [modal4Open, setModal4Open] = useState(false);
  const [modal5Open, setModal5Open] = useState(false);
  const [modal6Open, setModal6Open] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [formattedDateTime, setFormattedDateTime] = useState("");

  const fetchWhoData = useCallback(() => {
    const currentDate = moment();
    const weeksData = {};

    for (let i = 0; i < 4; i++) {
      const startOfWeek = currentDate
        .clone()
        .subtract(i, "weeks")
        .startOf("isoWeek");
      const endOfWeek = currentDate
        .clone()
        .subtract(i, "weeks")
        .endOf("isoWeek");

      weeksData[`week${i + 1}`] = {
        startDate: startOfWeek.format("YYYY-MM-DD"),
        endDate: endOfWeek.format("YYYY-MM-DD"),
        startTimestamp: startOfWeek.valueOf(),
        endTimestamp: endOfWeek.valueOf(),
      };
    }

    dispatch(
      getWhoScoreLoad({
        dateObject: weeksData,
        organisation: myid,
      })
    );
  }, [dispatch, myid]);

  useEffect(() => {
    fetchWhoData();
  }, [fetchWhoData]);

  useEffect(() => {
    if (whoAssessmentSuccess) {
      editReq = false;
      dispatch(requestScoreFail());
      setModal5Open(false);
      setModal6Open(true);
      setModal4Open(false);
      fetchWhoData();
    }
  }, [whoAssessmentSuccess, fetchWhoData]);

  const handleDateChange = (setFieldValue, date) => {
    setSelectedDate(date);
    setFieldValue("date", date);
  };

  const handleTimeChange = (setFieldValue, time) => {
    setSelectedTime(time);
    setFieldValue("time", time);
  };

  const handleSchedule = (values) => {
    const { date, time } = values;
    if (date && time) {
      const dateTime = moment(date)
        .set({
          hour: time.hour(),
          minute: time.minute(),
          second: time.second(),
        })
        .toISOString();

      const requestData = {
        date: dateTime,
        isScheduled: true,
        organisation: myid,
      };
      if (editReq) {
        dispatch(
          editrequestScoreLoad({
            date: dateTime,
            scheduleId: lastReqAssesmentData._id,
          })
        );
      } else {
        dispatch(requestScoreLoad(requestData));
      }
      const formattedDateTime = moment(dateTime).format(
        "MMMM DD, YYYY | hh:mmA"
      );
      setFormattedDateTime(formattedDateTime);
    } else {
      message.error("Please select both date and time.");
    }
  };

  const handleSendNow = () => {
    const currentDateTime = moment().toISOString();
    const requestData = {
      date: currentDateTime,
      isScheduled: false,
      organisation: myid,
    };
    dispatch(requestScoreLoad(requestData));
    const formattedDateTime = moment(currentDateTime).format(
      "MMMM DD, YYYY | hh:mmA"
    );
    setFormattedDateTime(formattedDateTime);
  };

  const handleEditSchedule = () => {
    editReq = true;
    setModal6Open(false);
    setModal5Open(true);
    dispatch(requestScoreFail());
  };

  const validationSchema = Yup.object().shape({
    date: Yup.date().nullable().required("Please select a date."),
    time: Yup.date().nullable().required("Please select a time."),
  });

  return (
    <div className="wh-assesment">
      <div className="content-e outter-space">
        <div className="user-heading">
          <div className="assessment-heading">
            <h1>WHO5 Assessment</h1>
            {upcomingAssessmentDate && (
              <p>
                Upcoming Assessment Date:{" "}
                <span>
                  {moment(upcomingAssessmentDate.date).format("MMMM D, YYYY")}
                </span>
              </p>
            )}
          </div>
          <div className="schedule-button-side">
            <div className="schedule-btn">
              <button onClick={() => setModal5Open(true)}>
                {" "}
                <span>
                  <img src={images.calender} alt="calender" />
                </span>{" "}
                Schedule{" "}
              </button>
            </div>
            <button onClick={() => setModal4Open(true)}>
              Request Assessment Now
            </button>
          </div>
        </div>

        <div className="time-frame">
          <WhoAllCharts />
        </div>
      </div>

      <Modal
        title=""
        className="modal-update"
        centered
        open={modal4Open}
        closable={true}
        onCancel={() => setModal4Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Request Assessment</h1>
          </div>
          <div className="schedule-send-now">
            <div className="btn-schedule send-now">
              <button
                onClick={() => {
                  setModal4Open(false);
                  setModal5Open(true);
                }}
              >
                Schedule
              </button>
            </div>
            <div className="btn-schedule">
              <button onClick={handleSendNow}>Send Now</button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title=""
        className="modal-update"
        centered
        open={modal5Open}
        closable={true}
        onCancel={() => setModal5Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Schedule WHO5 Assessment</h1>
            <div className="user-disp">
              <p>Sed consecte tur imper lla males ua daSr lla males ua</p>
              <p>daSr lla males ua daSed consectetur.</p>
            </div>
          </div>
          <div className="description-inner-circle">
            <div className="who-five">
              <Formik
                initialValues={{ date: null, time: null }}
                validationSchema={validationSchema}
                onSubmit={handleSchedule}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <div className="date-and-time">
                      <div className="select-date form-group">
                        <div className="textarea-label label-text">
                          <label>{appconstant.selectDate}</label>
                        </div>
                        <Space direction="vertical">
                          <Field name="date">
                            {({ field }) => (
                              <DatePicker
                                {...field}
                                onChange={(date) =>
                                  handleDateChange(setFieldValue, date)
                                }
                                value={selectedDate}
                                placeholder="Date"
                              />
                            )}
                          </Field>
                        </Space>
                        <ErrorMessage
                          name="date"
                          component="div"
                          className="text-red-500 text-xs mt-1"
                        />
                      </div>
                      <div className="select-date form-group">
                        <div className="textarea-label label-text">
                          <label>{appconstant.selectTime}</label>
                        </div>
                        <Field name="time">
                          {({ field }) => (
                            <TimePicker
                              {...field}
                              onChange={(time) =>
                                handleTimeChange(setFieldValue, time)
                              }
                              value={selectedTime}
                              placeholder="Time"
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="time"
                          component="div"
                          className="text-red-500 text-xs mt-1"
                        />
                      </div>
                    </div>
                    <div className="click-to-upload">
                      <div className="create-inner-circle-btn less-margin-top">
                        <button type="submit">Schedule</button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title=""
        className="modal-update"
        centered
        open={modal6Open}
        closable={true}
        onCancel={() => setModal6Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>Schedule WHO5 Assessment</h1>
          </div>
          <div className="description-inner-circle">
            <div className="who-five">
              <div className="scheduled-timing">
                <p>
                  Upcoming Assessment Date: <span>{formattedDateTime}</span>
                </p>
              </div>
            </div>
          </div>
          {lastReqAssesmentData && (
            <div className="click-to-upload">
              <div className="create-inner-circle-btn less-margin-inner">
                <button onClick={handleEditSchedule}>Edit Schedule</button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Who;
